"use client";
import { Filters } from "@/types/General";
import { Dispatch, SetStateAction, useState } from "react";

export const useFilters = (
  initialState: Filters,
): {
  selectedFilters: Filters;
  setSelectedFilters: Dispatch<SetStateAction<Filters>>;
  onSelectFilters: (name: string, paths: string[]) => Filters;
  onDeselectFilters: (name: string, paths: string[]) => Filters;
  setFilter: (name: string, paths: string[]) => Filters;
  onClearAll: () => Filters;
} => {
  const [selectedFilters, setSelectedFilters] = useState(initialState);

  const setFilter = (name: string, paths: string[]): Filters => {
    const newFilters = [...selectedFilters];
    const newFilter = newFilters.find(({ name: newName }) => newName === name);

    if (!newFilter) {
      newFilters.push({
        name,
        paths,
      });
    } else {
      newFilter.paths = Array.from(new Set(paths));
      if (newFilter.paths.length === 0) {
        const newFilterIndex = newFilters.findIndex(
          ({ name: newName }) => newName === name,
        );
        newFilters.splice(newFilterIndex, 1);
      }
    }
    setSelectedFilters(newFilters);
    return newFilters;
  };

  const onSelectFilters = (name: string, paths: string[]): Filters => {
    const newFilters = [...selectedFilters];
    const newFilter = newFilters.find(({ name: newName }) => newName === name);

    if (!newFilter) {
      newFilters.push({
        name,
        paths,
      });
    } else {
      newFilter.paths = Array.from(new Set([...newFilter.paths, ...paths]));
    }
    setSelectedFilters(newFilters);
    return newFilters;
  };

  const onDeselectFilters = (name: string, paths: string[]): Filters => {
    const newFilters = [...selectedFilters];
    const newFilter = newFilters.find(({ name: newName }) => newName === name);

    if (!newFilter) {
      return selectedFilters;
    } else {
      newFilter.paths = newFilter.paths.filter(
        (filter) => !paths.includes(filter),
      );
    }

    if (newFilter.paths.length === 0) {
      const newFilterIndex = newFilters.findIndex(
        ({ name: newName }) => newName === name,
      );
      newFilters.splice(newFilterIndex, 1);
    }
    setSelectedFilters(newFilters);
    return newFilters;
  };
  const onClearAll = (): Filters => {
    setSelectedFilters([]);
    return [];
  };

  return {
    selectedFilters,
    onSelectFilters,
    onDeselectFilters,
    onClearAll,
    setSelectedFilters,
    setFilter,
  };
};
